<template>
  <div class="card p-4">
    <div>{{stripeValidationMsg}}</div>
    <form @submit.prevent="createPaymentMethod">
      <div class="row">
        <div class="col-12">
          <div>Card Number</div>
          <div id="card-number-element" class="input-value form-control todo-form"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div>Expiry Date</div>
          <div id="card-expiry-element" class="input-value form-control todo-form"></div>
        </div>
        <div class="col-6">
          <div>CVV</div>
          <div id="card-cvc-element" class="input-value form-control todo-form"></div>
        </div>
      </div>
      <div class="col-xl edit-company-action-button-row" style="padding: 0px;margin-top:0px">
        <button type="button" class="todo-form-cancel-button btn-outline-secondary">Cancel</button>
        <button type="submit" :disabled="isSaving" class="todo-form-submit-button btn btn-primary">
          <!-- {{SubmitButtonTitle}} -->
          Save
          <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>

          <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="isSaving"></i> -->
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import api from "../../../axios_api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isSaving: false,
      stripe: null,
      stripeValidationMsg: "",
      elements: null,
      cardForm: {},
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCVCElement: null,
      customerObj: null
    };
  },
  computed: {
    ...mapGetters("user", ["user"])
  },
  mounted() {
    this.stripe = Stripe("pk_test_H4slTE8TzhaResbLqMzqNMmz00HEFZOtsh");
    this.createAndMountFormElement();
    // this.cardNumberElement.on("change", this.setValidationError);
    // this.cardExpiryElement.on("change", this.setValidationError);
    // this.cardCVCElement.on("change", this.setValidationError);
    // setTimeout(() => {
    //   if (this.user && this.user.email) {
    //     this.createCustomer();
    //   }
    // }, 500);
  },
  methods: {
    createCustomer() {
      api
        .post(`/create-customer/${this.$route.params.account_id}`, {
          encrypt: { data: this.user.email }
        })
        .then(data => {
          this.customerObj = data.data.encrypt.success;
        })
        .catch(err => {
          console.log({ err });
        });
    },
    createAndMountFormElement() {
      var elements = this.stripe.elements();
      this.elements = elements;
      this.cardNumberElement = elements.create("cardNumber");
      this.cardNumberElement.mount("#card-number-element");
      this.cardExpiryElement = elements.create("cardExpiry");
      this.cardExpiryElement.mount("#card-expiry-element");
      this.cardCvcElement = elements.create("cardCvc");
      this.cardCvcElement.mount("#card-cvc-element");
    },
    setValidationError(event) {
      this.stripeValidationMsg = event.error ? event.error.message : "";
    },
    createPaymentMethod() {
      let self = this;
      this.isSaving = true;
      return this.stripe
        .createPaymentMethod({
          type: "card",
          card: this.cardNumberElement
        })
        .then(result => {
          if (result.error) {
            self.isSaving = false;
            console.log(result.error);
          } else {
            self.createSubscription({
              paymentMethodId: result.paymentMethod.id,
              priceId: "price_1Gx7BzC86VOLEvv5fZVcJU1L"
            });
          }
        });
    },
    createSubscription({ paymentMethodId, priceId }) {
      let self = this;
      let payload = {
        paymentMethodId,
        priceId,
        quantity: 5,
        amount: 100,
        type: "Monthly",
        email: this.user.email
      };
      api
        .post(`/create-subscription/${this.$route.params.account_id}`, {
          encrypt: { data: payload }
        })
        .then(data => {
          const { latest_invoice } = data.data.encrypt.success;
          const { payment_intent } = latest_invoice;
          if (payment_intent) {
            const { client_secret, status } = payment_intent;
            console.log(status);
            if (status === "requires_action") {
              self.handleActionRequires(client_secret);
              self.isSaving = false;
            } else {
              if (status == "succeeded") console.log("success");
              self.isSaving = false;
            }
          }
        })
        .catch(err => {
          console.log({ err });
        });
    },
    handleActionRequires(client_secret) {
      let self = this;
      return this.stripe
        .confirmCardPayment(client_secret, {
          setup_future_usage: "off_session"
        })
        .then(data => {
          console.log(data);
          self.isSaving = false;
        })
        .catch(err => {
          console.log({ err });
          self.isSaving = false;
        });
    }
  }
};
</script>
<style>
</style>